var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"ebx-search-box__clear-button-text"},[_vm._v("\n  "+_vm._s(_vm.parent.$x.messages.custom.clearSearchInput)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }